// Minimal language/i18n strings for Garlic Capital
export const translations = {
  en: {
    brand: "Garlic Capital",
    brand_sub: "Lahsun Mandi",
    nav: {
      home: "Home",
      mandi: "Live Mandi Prices",
      mandi_short: "Mandi",
      trade: "Trading Floor",
      trade_short: "Trading Floor",
      analytics: "Analytics",
      about: "About Us",
      contact: "Contact Us",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      legal_info: "Legal Information",
      profile: "Profile",
      login: "Login",
      logout: "Logout",
      sell: "Sell Garlic",
      menu: "Menu",
    },
    home: {
      hero_eyebrow: "India's Garlic Marketplace",
      hero_title: "Fair Prices for Farmers. Quality Garlic for Traders.",
      hero_sub: "Live mandi rates, direct buyer-seller connection, and transparent price trends — all in one place.",
      cta_explore: "Explore Mandi Rates",
      cta_sell: "List Your Garlic",
      stats_mandis: "Mandis Tracked",
      stats_listings: "Active Listings",
      stats_farmers: "Trusted Farmers",
      modules_title: "Three pillars of the Garlic Capital ecosystem",
      m1_title: "Mandi Dashboard",
      m1_desc: "Live garlic rates from major Indian mandis updated daily.",
      m2_title: "Trading Floor",
      m2_desc: "Browse listings, search by city or variety, contact sellers directly.",
      m3_title: "Price Analytics",
      m3_desc: "60-day price trends and mandi-by-mandi comparison.",
      trust_title: "Why Garlic Capital?",
      trust_1: "No middlemen — direct farmer to trader",
      trust_2: "Transparent pricing from real mandis",
      trust_3: "Mobile-first, designed for everyone",
    },
    mandi: {
      title: "Live Mandi Prices",
      subtitle: "Live garlic (lahsun) rates across India",
      search_placeholder: "Search by state, district or mandi...",
      filter_all: "All",
      all_states: "All States",
      all_districts: "All Districts",
      select_state_first: "select state",
      all_varieties: "All Varieties",
      col_state: "State",
      col_district: "District",
      col_mandi: "Mandi",
      col_variety: "Variety",
      col_min: "Min ₹/kg",
      col_max: "Max ₹/kg",
      col_avg: "Avg ₹/kg",
      col_modal: "Modal",
      col_arrival: "Arrival",
      col_trend: "Trend",
      cell_min: "Min",
      cell_modal: "Modal",
      cell_max: "Max",
      showing_note: "mandis across India · Filtered by state/district",
      showing_prefix: "Showing",
      no_data: "No mandi data available",
      source_live: "Live from data.gov.in",
      source_cache: "Cached · retrying",
      updated_label: "Updated:",
      last_updated: "Last updated:",
      just_now: "just now",
      min_ago: "min ago",
      hr_ago: "hr ago",
    },
    trade: {
      title: "Trading Floor",
      subtitle: "Buy & sell garlic directly from verified sellers",
      filter_city: "City",
      filter_variety: "Variety",
      all_cities: "All Cities",
      all_varieties: "All Varieties",
      search: "Search",
      contact: "Contact Seller",
      no_listings: "No listings match your filters",
      kg: "kg available",
      sell_cta: "List Your Garlic for Sale",
    },
    create: {
      title: "List Your Garlic",
      subtitle: "Fill the details and reach thousands of traders",
      variety: "Variety",
      quantity: "Quantity (kg)",
      price: "Price per kg (₹)",
      image: "Image URL (optional)",
      description: "Description (optional)",
      submit: "Publish Listing",
      success: "Listing published successfully!",
      login_required: "Please login to create a listing",
    },
    analytics: {
      title: "Price Analytics",
      subtitle: "Garlic price trends over the last 60 days",
      select_mandi: "Select Mandi",
      avg_price: "Average Price (₹/kg)",
      compare_title: "Mandi Comparison",
      compare_sub: "Current average prices across major mandis",
    },
    auth: {
      login_title: "Welcome to Garlic Capital",
      login_sub: "Sign in to list your garlic, save searches, and contact traders.",
      continue_google: "Continue with Google",
      privacy_note: "We use Google Sign-In so you never need a password. We only access your name, email and profile picture.",
      error_generic: "Sign-in failed. Please try again.",
      name_label: "Your Name",
      role_label: "I am a",
      role_farmer: "Farmer (Seller)",
      role_trader: "Trader (Buyer)",
      city_label: "City",
      phone_label: "Phone Number (for buyer contact)",
    },
    profile: {
      title: "My Profile",
      welcome: "Welcome! Please complete your profile so buyers can contact you.",
      my_listings: "My Listings",
      edit: "Edit Profile",
      save: "Save",
      no_listings: "You haven't listed anything yet.",
      add_listing: "Add Your First Listing",
      mark_sold: "Mark Sold",
      delete: "Delete",
      confirm_delete: "Delete this listing?",
      phone_required_for_listing: "Add your phone in profile so traders can call you.",
    },
    about: {
      title: "About Garlic Capital",
      p1_rest: "India's first dedicated and advanced platform designed exclusively for the garlic (lahsun) trade and farming community.",
      p2: "Our mission is to empower farmers, traders, and agri-entrepreneurs by bridging the gap between local mandis and modern digital technology. We provide accurate, automated, and real-time daily garlic prices from major agricultural markets across India, ensuring absolute transparency in every transaction.",
      p3: "With a user-friendly, clean interface, Garlic Capital eliminates outdated and complex data structures, allowing you to access critical market insights instantly. Whether you want to track live mandi trends or manage your profile securely via Google Login, we are committed to being your most trusted partner in the garlic ecosystem.",
    },
    contact: {
      title: "Contact Us",
      subtitle: "Have a question, partnership idea, or need help? Send us a message and we'll get back to you.",
      form_name: "Your Name",
      form_email: "Email",
      form_phone: "Phone (optional)",
      form_message: "Your Message",
      send: "Send Message",
      send_another: "Send another message",
      success: "Thank you! Your message has been sent. We'll reach out within 24 hours.",
    },
    legal: {
      privacy_title: "Privacy Policy",
      privacy_intro: "Your privacy matters to us. This page explains exactly what data Garlic Capital collects and how we use it.",
      last_updated: "Last updated: January 2026",
      privacy_s1_title: "What We Collect",
      privacy_s1: "When you sign in with Google, we securely receive and store only your name, email address, and profile picture. We do not request access to your contacts, calendar, or any other Google data.",
      privacy_s2_title: "Why We Collect It",
      privacy_s2: "Your name and email are used purely for login and account identification — so you can list garlic, save searches, and contact traders under your verified identity. We do not use your data for advertising.",
      privacy_s3_title: "We Do Not Share Your Data",
      privacy_s3: "We do not sell, rent, or share your personal data with any third party. Your information stays within Garlic Capital and is never disclosed to advertisers, data brokers, or marketing partners.",
      privacy_s4_title: "Data Security",
      privacy_s4: "All data is transmitted over encrypted HTTPS connections and stored in secured databases with strict access controls. Authentication is handled via Google Sign-In, so Garlic Capital never sees or stores your password.",
      privacy_s5_title: "Your Rights",
      privacy_s5: "You can request deletion of your account and all associated data at any time by contacting us. We will process such requests within 7 working days.",
      privacy_s6_title: "Contact",
      privacy_s6: "For any privacy concerns, write to us via the Contact Us page.",

      terms_title: "Terms & Conditions",
      terms_intro: "Please read these terms carefully before using Garlic Capital. By creating an account, you agree to be bound by them.",
      terms_s1_title: "About the Service",
      terms_s1: "Garlic Capital is a digital platform that provides daily garlic (lahsun) market rates aggregated from major Indian mandis, along with a trading floor where verified farmers and traders can connect directly.",
      terms_s2_title: "1-Month Free Trial",
      terms_s2: "Every new user gets a 1-month free trial with full access to live mandi rates, listings, and analytics — no payment details required upfront.",
      terms_s3_title: "Subscription After Trial",
      terms_s3: "After the 1-month free trial ends, continued access will transition to a paid subscription of ₹30 per month. You will be notified before the trial ends and may choose to subscribe or stop using the platform with no further charges.",
      terms_s4_title: "Acceptable Use",
      terms_s4: "You agree to use the platform honestly: list real garlic stock, quote genuine prices, and treat other users with respect. We reserve the right to suspend accounts that post false listings, spam, or harassing content.",
      terms_s5_title: "Price Information",
      terms_s5: "Mandi rates shown are aggregated from public market sources and updated daily. While we strive for accuracy, prices may vary on actual transaction day. Garlic Capital is not liable for trade decisions made solely based on displayed rates.",
      terms_s6_title: "Account Termination",
      terms_s6: "You may delete your account at any time. We may also terminate accounts that violate these terms. Upon termination, your active listings will be removed.",
      terms_s7_title: "Changes to Terms",
      terms_s7: "We may update these terms occasionally. Significant changes will be notified via email and on this page.",
      terms_s8_title: "Governing Law",
      terms_s8: "These terms are governed by the laws of India. Any disputes will be subject to the jurisdiction of courts in Rajasthan.",

      legalinfo_title: "Legal Information",
      legalinfo_intro: "Understand who we are, how our market data is sourced, and the compliance standards we uphold.",
      legalinfo_s1_title: "Platform Transparency",
      legalinfo_s1: "Garlic Capital is an independent digital information and B2B marketplace platform designed to empower Indian farmers, traders, and commission agents. We are not affiliated with any government body or agricultural corporation, and we operate as a neutral technology layer between market participants.",
      legalinfo_s2_title: "Data & Market Rates",
      legalinfo_s2: "All daily garlic market prices and updates provided on the platform are compiled transparently from reliable market sources for informational purposes. While we make every effort to keep this data accurate and current, users are encouraged to verify prices at the point of transaction.",
      legalinfo_s3_title: "Compliance",
      legalinfo_s3: "The platform operates in full compliance with the digital service and data protection guidelines of India, ensuring a secure environment for user interactions and future subscription services. We follow best practices around data storage, user consent, and transparent business communication.",
    },
    footer: {
      tagline: "India's first dedicated lahsun trade platform.",
      explore: "Explore",
      company: "Company",
      legal: "Legal",
      rights: "All Rights Reserved",
    },
    common: {
      loading: "Loading...",
      error: "Something went wrong",
      back: "Back",
      cancel: "Cancel",
    },
    dashboard: {
      welcome: "Welcome",
      subtitle: "Your Garlic Capital dashboard",
      stats_modal_title: "Today's Modal Price",
      stats_modal_sub: "Pan-India Average (Lahsun)",
      stats_best_title: "Best Rate Today",
      stats_best_sub_prefix: "at",
      stats_best_badge: "Highest today",
      stats_arrival_title: "Total Arrivals",
      stats_arrival_sub: "Pan-India (Lahsun)",
      stats_arrival_unit: "quintals",
      stats_arrival_vs_avg: "vs 7-day avg",
      stats_active_title: "Active Mandis",
      stats_active_sub: "Reporting today",
      stats_active_of: "of",
      stats_active_active: "active",
      profile_title: "Your Profile",
      profile_edit: "Edit Profile",
      profile_add_phone: "Add phone number",
      khaad_title: "Khaad",
      khaad_sub: "Fertilizers",
      khaad_desc: "Browse quality fertilizers for your garlic crop.",
      beej_title: "Beej",
      beej_sub: "Seeds",
      beej_desc: "Certified garlic seed varieties from trusted suppliers.",
      schemes_title: "Government Schemes",
      schemes_sub: "For Farmers",
      schemes_desc: "Latest agricultural schemes, subsidies and support.",
      sub_title: "Subscription Plan",
      sub_coming_soon_badge: "Premium Features Coming Soon! Enjoy Free Access For Now.",
      sub_free: "Free Trial",
      sub_days_left: "days remaining",
      sub_expired: "Trial expired",
      sub_price: "₹30/month",
      sub_after_trial: "after your 1-month free trial",
      pay_upi: "Pay via UPI",
      pay_card: "Pay via Card",
      pay_netbanking: "Net Banking",
      pay_note: "Secure payments — Coming soon",
      coming_soon: "Coming Soon",
      explore: "Explore",
      logout_title: "Sign out of Garlic Capital",
      logout_desc: "You'll be safely signed out of your Google account on this device.",
      logout_btn: "Log Out",
    },
    disclaimer: {
      label: "Disclaimer:",
      text: "Mandi prices shown here are for general information only. Please confirm the rates with your local mandi before making any trade.",
      source_label: "Data Source:",
      source: "Agmarknet / Ministry of Agriculture & Farmers Welfare, Govt. of India",
    },
  },
  hi: {
    brand: "गार्लिक कैपिटल",
    brand_sub: "लहसुन मंडी",
    nav: {
      home: "होम",
      mandi: "लाइव मंडी भाव",
      mandi_short: "मंडी",
      trade: "ट्रेडिंग फ्लोर",
      trade_short: "व्यापार",
      analytics: "विश्लेषण",
      about: "हमारे बारे में",
      contact: "संपर्क करें",
      terms: "नियम और शर्तें",
      privacy: "गोपनीयता नीति",
      legal_info: "कानूनी जानकारी",
      profile: "प्रोफ़ाइल",
      login: "लॉगिन",
      logout: "लॉगआउट",
      sell: "लहसुन बेचें",
      menu: "मेन्यू",
    },
    home: {
      hero_eyebrow: "भारत का लहसुन बाज़ार",
      hero_title: "किसानों को सही दाम। व्यापारियों को बेहतरीन माल।",
      hero_sub: "लाइव मंडी भाव, सीधा खरीदार-विक्रेता संपर्क और पारदर्शी मूल्य रुझान — सब एक जगह।",
      cta_explore: "मंडी भाव देखें",
      cta_sell: "अपना लहसुन डालें",
      stats_mandis: "मंडियाँ ट्रैक",
      stats_listings: "सक्रिय लिस्टिंग",
      stats_farmers: "भरोसेमंद किसान",
      modules_title: "गार्लिक कैपिटल के तीन मुख्य स्तंभ",
      m1_title: "मंडी डैशबोर्ड",
      m1_desc: "प्रमुख भारतीय मंडियों से लाइव लहसुन भाव, रोज़ अपडेट।",
      m2_title: "ट्रेडिंग फ्लोर",
      m2_desc: "लिस्टिंग देखें, शहर/किस्म से खोजें, सीधे विक्रेता से संपर्क।",
      m3_title: "मूल्य विश्लेषण",
      m3_desc: "60 दिन का मूल्य रुझान और मंडी तुलना।",
      trust_title: "गार्लिक कैपिटल क्यों?",
      trust_1: "कोई बिचौलिया नहीं — सीधे किसान से व्यापारी तक",
      trust_2: "असली मंडियों से पारदर्शी मूल्य निर्धारण",
      trust_3: "मोबाइल-फर्स्ट, सबके लिए डिज़ाइन किया गया",
    },
    mandi: {
      title: "लाइव मंडी भाव",
      subtitle: "पूरे भारत में लहसुन के लाइव भाव",
      search_placeholder: "राज्य, जिला या मंडी से खोजें...",
      filter_all: "सभी",
      all_states: "सभी राज्य",
      all_districts: "सभी जिले",
      select_state_first: "पहले राज्य चुनें",
      all_varieties: "सभी किस्में",
      col_state: "राज्य",
      col_district: "जिला",
      col_mandi: "मंडी",
      col_variety: "किस्म",
      col_min: "न्यूनतम ₹/किलो",
      col_max: "अधिकतम ₹/किलो",
      col_avg: "औसत ₹/किलो",
      col_modal: "मॉडल",
      col_arrival: "आवक तिथि",
      col_trend: "रुझान",
      cell_min: "न्यूनतम",
      cell_modal: "मॉडल",
      cell_max: "अधिकतम",
      showing_note: "मंडियाँ भारत भर से · राज्य/जिले के अनुसार फ़िल्टर की गईं",
      showing_prefix: "दिखा रहे हैं",
      no_data: "कोई मंडी डेटा उपलब्ध नहीं",
      source_live: "data.gov.in से लाइव",
      source_cache: "कैश से · पुनः प्रयासरत",
      updated_label: "अपडेट:",
      last_updated: "आखिरी बार अपडेट:",
      just_now: "अभी-अभी",
      min_ago: "मिनट पहले",
      hr_ago: "घंटे पहले",
    },
    trade: {
      title: "ट्रेडिंग फ्लोर",
      subtitle: "सत्यापित विक्रेताओं से सीधे लहसुन खरीदें/बेचें",
      filter_city: "शहर",
      filter_variety: "किस्म",
      all_cities: "सभी शहर",
      all_varieties: "सभी किस्में",
      search: "खोजें",
      contact: "विक्रेता से संपर्क",
      no_listings: "कोई लिस्टिंग नहीं मिली",
      kg: "किलो उपलब्ध",
      sell_cta: "अपना लहसुन बिक्री के लिए डालें",
    },
    create: {
      title: "अपना लहसुन डालें",
      subtitle: "विवरण भरें और हज़ारों व्यापारियों तक पहुँचें",
      variety: "किस्म",
      quantity: "मात्रा (किलो)",
      price: "प्रति किलो दाम (₹)",
      image: "तस्वीर URL (वैकल्पिक)",
      description: "विवरण (वैकल्पिक)",
      submit: "लिस्टिंग प्रकाशित करें",
      success: "लिस्टिंग सफलतापूर्वक प्रकाशित!",
      login_required: "लिस्टिंग बनाने के लिए लॉगिन करें",
    },
    analytics: {
      title: "मूल्य विश्लेषण",
      subtitle: "पिछले 60 दिनों के लहसुन मूल्य रुझान",
      select_mandi: "मंडी चुनें",
      avg_price: "औसत मूल्य (₹/किलो)",
      compare_title: "मंडी तुलना",
      compare_sub: "प्रमुख मंडियों में वर्तमान औसत भाव",
    },
    auth: {
      login_title: "गार्लिक कैपिटल में स्वागत",
      login_sub: "अपना लहसुन डालने, खोज सेव करने और व्यापारियों से संपर्क के लिए साइन इन करें।",
      continue_google: "Google से जारी रखें",
      privacy_note: "हम Google Sign-In उपयोग करते हैं — पासवर्ड की ज़रूरत नहीं। हम सिर्फ़ आपका नाम, ईमेल और प्रोफ़ाइल तस्वीर एक्सेस करते हैं।",
      error_generic: "साइन इन विफल। कृपया फिर कोशिश करें।",
      name_label: "आपका नाम",
      role_label: "मैं हूँ",
      role_farmer: "किसान (विक्रेता)",
      role_trader: "व्यापारी (खरीदार)",
      city_label: "शहर",
      phone_label: "फ़ोन नंबर (खरीदार संपर्क के लिए)",
    },
    profile: {
      title: "मेरी प्रोफ़ाइल",
      welcome: "स्वागत है! कृपया अपनी प्रोफ़ाइल पूरी करें ताकि खरीदार आपसे संपर्क कर सकें।",
      my_listings: "मेरी लिस्टिंग",
      edit: "प्रोफ़ाइल संपादित करें",
      save: "सेव करें",
      no_listings: "अभी तक कोई लिस्टिंग नहीं।",
      add_listing: "पहली लिस्टिंग जोड़ें",
      mark_sold: "बिक गया",
      delete: "हटाएँ",
      confirm_delete: "क्या यह लिस्टिंग हटानी है?",
      phone_required_for_listing: "प्रोफ़ाइल में फ़ोन जोड़ें ताकि व्यापारी आपको कॉल कर सकें।",
    },
    about: {
      title: "गार्लिक कैपिटल के बारे में",
      p1_rest: "में आपका स्वागत है — भारत का पहला समर्पित और उन्नत प्लेटफ़ॉर्म, जो विशेष रूप से लहसुन व्यापार और किसान समुदाय के लिए बनाया गया है।",
      p2: "हमारा उद्देश्य किसानों, व्यापारियों और कृषि-उद्यमियों को सशक्त बनाना है — स्थानीय मंडियों और आधुनिक डिजिटल तकनीक के बीच की दूरी मिटाकर। हम पूरे भारत की प्रमुख कृषि मंडियों से सटीक, स्वचालित और रीयल-टाइम दैनिक लहसुन भाव उपलब्ध कराते हैं, ताकि हर लेन-देन में पूर्ण पारदर्शिता बनी रहे।",
      p3: "एक उपयोगकर्ता-अनुकूल, साफ़-सुथरे इंटरफ़ेस के साथ, गार्लिक कैपिटल पुरानी और जटिल डेटा संरचनाओं को हटाकर महत्वपूर्ण बाज़ार जानकारी तुरंत उपलब्ध कराता है। चाहे आप लाइव मंडी रुझान देखना चाहें या Google Login से सुरक्षित रूप से अपनी प्रोफ़ाइल मैनेज करना — हम लहसुन तंत्र में आपके सबसे भरोसेमंद साथी बनने के लिए प्रतिबद्ध हैं।",
    },
    contact: {
      title: "संपर्क करें",
      subtitle: "कोई सवाल, साझेदारी का विचार, या मदद चाहिए? हमें संदेश भेजें, हम जल्द ही संपर्क करेंगे।",
      form_name: "आपका नाम",
      form_email: "ईमेल",
      form_phone: "फ़ोन (वैकल्पिक)",
      form_message: "आपका संदेश",
      send: "संदेश भेजें",
      send_another: "एक और संदेश भेजें",
      success: "धन्यवाद! आपका संदेश भेज दिया गया। हम 24 घंटे में संपर्क करेंगे।",
    },
    legal: {
      privacy_title: "गोपनीयता नीति",
      privacy_intro: "आपकी गोपनीयता हमारे लिए महत्वपूर्ण है। यह पृष्ठ बताता है कि गार्लिक कैपिटल कौन-सा डेटा एकत्र करता है और कैसे उपयोग करता है।",
      last_updated: "अंतिम अपडेट: जनवरी 2026",
      privacy_s1_title: "हम क्या एकत्र करते हैं",
      privacy_s1: "जब आप Google से साइन इन करते हैं, तो हम सुरक्षित रूप से केवल आपका नाम, ईमेल पता और प्रोफ़ाइल तस्वीर प्राप्त करके स्टोर करते हैं। हम आपके कॉन्टैक्ट्स, कैलेंडर या किसी अन्य Google डेटा की अनुमति नहीं माँगते।",
      privacy_s2_title: "हम क्यों एकत्र करते हैं",
      privacy_s2: "आपका नाम और ईमेल केवल लॉगिन और खाता पहचान के लिए उपयोग किए जाते हैं — ताकि आप अपनी सत्यापित पहचान से लहसुन लिस्ट कर सकें, खोज सेव कर सकें और व्यापारियों से संपर्क कर सकें। हम आपके डेटा का उपयोग विज्ञापनों के लिए नहीं करते।",
      privacy_s3_title: "हम आपका डेटा साझा नहीं करते",
      privacy_s3: "हम आपका व्यक्तिगत डेटा किसी भी तीसरे पक्ष को बेचते, किराये पर देते या साझा नहीं करते। आपकी जानकारी केवल गार्लिक कैपिटल के भीतर रहती है — विज्ञापनदाताओं, डेटा ब्रोकर या मार्केटिंग साझेदारों के साथ कभी साझा नहीं की जाती।",
      privacy_s4_title: "डेटा सुरक्षा",
      privacy_s4: "सभी डेटा एन्क्रिप्टेड HTTPS कनेक्शन पर भेजा जाता है और सुरक्षित डेटाबेस में सख्त एक्सेस कंट्रोल के साथ स्टोर होता है। प्रमाणीकरण Google Sign-In के द्वारा होता है, इसलिए गार्लिक कैपिटल आपका पासवर्ड कभी नहीं देखता या स्टोर नहीं करता।",
      privacy_s5_title: "आपके अधिकार",
      privacy_s5: "आप कभी भी अपना खाता और सम्बंधित सभी डेटा हटाने का अनुरोध कर सकते हैं। हम ऐसे अनुरोध 7 कार्य दिवसों में पूरे करेंगे।",
      privacy_s6_title: "संपर्क",
      privacy_s6: "किसी भी गोपनीयता संबंधी चिंता के लिए कृपया Contact Us पृष्ठ से लिखें।",

      terms_title: "नियम और शर्तें",
      terms_intro: "कृपया गार्लिक कैपिटल उपयोग करने से पहले इन शर्तों को ध्यान से पढ़ें। खाता बनाकर आप इनसे बंधे हुए माने जाएँगे।",
      terms_s1_title: "सेवा के बारे में",
      terms_s1: "गार्लिक कैपिटल एक डिजिटल प्लेटफ़ॉर्म है जो प्रमुख भारतीय मंडियों से एकत्रित दैनिक लहसुन बाज़ार भाव उपलब्ध कराता है, साथ ही एक ट्रेडिंग फ्लोर जहाँ सत्यापित किसान और व्यापारी सीधे जुड़ सकते हैं।",
      terms_s2_title: "1 महीने का मुफ़्त ट्रायल",
      terms_s2: "हर नए उपयोगकर्ता को 1 महीने का मुफ़्त ट्रायल मिलता है जिसमें लाइव मंडी भाव, लिस्टिंग और एनालिटिक्स का पूरा एक्सेस होता है — कोई पेमेंट डिटेल पहले देने की ज़रूरत नहीं।",
      terms_s3_title: "ट्रायल के बाद सब्सक्रिप्शन",
      terms_s3: "1 महीने का मुफ़्त ट्रायल समाप्त होने के बाद, आगे के एक्सेस के लिए ₹30 प्रति माह का सब्सक्रिप्शन लागू होगा। ट्रायल समाप्त होने से पहले आपको सूचित किया जाएगा और आप सब्सक्राइब करने या प्लेटफ़ॉर्म छोड़ने का विकल्प चुन सकते हैं — कोई अतिरिक्त शुल्क नहीं।",
      terms_s4_title: "उचित उपयोग",
      terms_s4: "आप ईमानदारी से प्लेटफ़ॉर्म उपयोग करने पर सहमत हैं: असली लहसुन स्टॉक लिस्ट करें, सही दाम बोलें, और अन्य उपयोगकर्ताओं के साथ सम्मान से पेश आएँ। झूठी लिस्टिंग, स्पैम या उत्पीड़न पर हम खाते निलंबित कर सकते हैं।",
      terms_s5_title: "मूल्य जानकारी",
      terms_s5: "दिखाए गए मंडी भाव सार्वजनिक बाज़ार स्रोतों से एकत्रित हैं और रोज़ अपडेट होते हैं। हम सटीकता के लिए प्रयासरत हैं, परंतु वास्तविक लेन-देन के दिन भाव भिन्न हो सकते हैं। केवल दिखाए गए भावों के आधार पर लिए गए निर्णयों के लिए गार्लिक कैपिटल ज़िम्मेदार नहीं है।",
      terms_s6_title: "खाता समाप्ति",
      terms_s6: "आप कभी भी अपना खाता हटा सकते हैं। हम भी उन खातों को बंद कर सकते हैं जो इन शर्तों का उल्लंघन करते हैं। समाप्ति पर आपकी सक्रिय लिस्टिंग हटा दी जाएँगी।",
      terms_s7_title: "शर्तों में बदलाव",
      terms_s7: "हम कभी-कभी इन शर्तों को अपडेट कर सकते हैं। महत्वपूर्ण बदलाव ईमेल और इस पृष्ठ पर सूचित किए जाएँगे।",
      terms_s8_title: "अधिकार क्षेत्र",
      terms_s8: "ये शर्तें भारत के कानूनों द्वारा शासित हैं। कोई भी विवाद राजस्थान के न्यायालयों के अधिकार क्षेत्र में होगा।",

      legalinfo_title: "कानूनी जानकारी",
      legalinfo_intro: "जानें हम कौन हैं, हमारा बाज़ार डेटा कहाँ से आता है, और हम किन अनुपालन मानकों का पालन करते हैं।",
      legalinfo_s1_title: "प्लेटफ़ॉर्म पारदर्शिता",
      legalinfo_s1: "गार्लिक कैपिटल एक स्वतंत्र डिजिटल सूचना और B2B मार्केटप्लेस प्लेटफ़ॉर्म है, जो भारतीय किसानों, व्यापारियों और कमीशन एजेंटों को सशक्त बनाने के लिए बनाया गया है। हम किसी सरकारी संस्था या कृषि निगम से सम्बद्ध नहीं हैं और बाज़ार प्रतिभागियों के बीच एक तटस्थ तकनीकी परत के रूप में कार्य करते हैं।",
      legalinfo_s2_title: "डेटा और बाज़ार भाव",
      legalinfo_s2: "प्लेटफ़ॉर्म पर उपलब्ध सभी दैनिक लहसुन बाज़ार भाव और अपडेट विश्वसनीय बाज़ार स्रोतों से पारदर्शी रूप से एकत्रित किए जाते हैं और केवल सूचना के उद्देश्य से हैं। हम सटीकता और समय-अनुकूलता बनाए रखने का पूरा प्रयास करते हैं, फिर भी उपयोगकर्ताओं को लेन-देन के समय भाव की पुष्टि करने की सलाह दी जाती है।",
      legalinfo_s3_title: "अनुपालन",
      legalinfo_s3: "यह प्लेटफ़ॉर्म भारत के डिजिटल सेवा और डेटा सुरक्षा दिशा-निर्देशों के पूर्ण अनुपालन में कार्य करता है, जिससे उपयोगकर्ता की बातचीत और भविष्य की सब्सक्रिप्शन सेवाओं के लिए सुरक्षित वातावरण सुनिश्चित होता है। हम डेटा संग्रहण, उपयोगकर्ता सहमति और पारदर्शी व्यापारिक संचार से जुड़े सर्वोत्तम अभ्यासों का पालन करते हैं।",
    },
    footer: {
      tagline: "भारत का पहला समर्पित लहसुन व्यापार प्लेटफ़ॉर्म।",
      explore: "खोजें",
      company: "कंपनी",
      legal: "कानूनी",
      rights: "सर्वाधिकार सुरक्षित",
    },
    common: {
      loading: "लोड हो रहा है...",
      error: "कुछ गलत हुआ",
      back: "वापस",
      cancel: "रद्द करें",
    },
    dashboard: {
      welcome: "स्वागत है",
      subtitle: "आपका गार्लिक कैपिटल डैशबोर्ड",
      stats_modal_title: "आज का मॉडल भाव",
      stats_modal_sub: "अखिल भारतीय औसत (लहसुन)",
      stats_best_title: "आज का सर्वोत्तम भाव",
      stats_best_sub_prefix: "मंडी",
      stats_best_badge: "सर्वाधिक आज",
      stats_arrival_title: "कुल आवक",
      stats_arrival_sub: "अखिल भारतीय (लहसुन)",
      stats_arrival_unit: "क्विंटल",
      stats_arrival_vs_avg: "7-दिन औसत की तुलना में",
      stats_active_title: "सक्रिय मंडियाँ",
      stats_active_sub: "आज रिपोर्ट कर रही हैं",
      stats_active_of: "में से",
      stats_active_active: "सक्रिय",
      profile_title: "आपकी प्रोफ़ाइल",
      profile_edit: "प्रोफ़ाइल संपादित करें",
      profile_add_phone: "फ़ोन नंबर जोड़ें",
      khaad_title: "खाद",
      khaad_sub: "उर्वरक",
      khaad_desc: "अपनी लहसुन फ़सल के लिए गुणवत्तापूर्ण उर्वरक देखें।",
      beej_title: "बीज",
      beej_sub: "उन्नत किस्में",
      beej_desc: "विश्वसनीय आपूर्तिकर्ताओं से प्रमाणित लहसुन बीज।",
      schemes_title: "सरकारी योजनाएँ",
      schemes_sub: "किसानों के लिए",
      schemes_desc: "नवीनतम कृषि योजनाएँ, सब्सिडी और सहायता।",
      sub_title: "सब्सक्रिप्शन प्लान",
      sub_coming_soon_badge: "प्रीमियम सुविधाएँ जल्द आ रही हैं! अभी मुफ़्त एक्सेस का आनंद लें।",
      sub_free: "मुफ़्त ट्रायल",
      sub_days_left: "दिन शेष",
      sub_expired: "ट्रायल समाप्त",
      sub_price: "₹30/माह",
      sub_after_trial: "1 महीने के मुफ़्त ट्रायल के बाद",
      pay_upi: "UPI से भुगतान",
      pay_card: "कार्ड से भुगतान",
      pay_netbanking: "नेट बैंकिंग",
      pay_note: "सुरक्षित भुगतान — जल्द उपलब्ध",
      coming_soon: "जल्द आ रहा है",
      explore: "खोजें",
      logout_title: "गार्लिक कैपिटल से साइन आउट",
      logout_desc: "आप इस डिवाइस से अपने Google खाते से सुरक्षित रूप से साइन आउट हो जाएँगे।",
      logout_btn: "लॉग आउट",
    },
    disclaimer: {
      label: "अस्वीकरण:",
      text: "यहाँ दिखाए गए मंडी भाव केवल सामान्य जानकारी के लिए हैं। किसी भी व्यापारिक सौदे से पहले अपनी स्थानीय मंडी से भाव की पुष्टि अवश्य कर लें।",
      source_label: "डेटा स्रोत:",
      source: "एगमार्कनेट / कृषि एवं किसान कल्याण मंत्रालय, भारत सरकार",
    },
  },
};
